document.addEventListener('DOMContentLoaded', function () {
  const callback = function (entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('active');
        observer.unobserve(entry.target);
      }
    });
  };

  const options = {
    threshold: 0.02,
    rootMargin: '0px',
  };

  const targets = document.querySelectorAll('[data-animated]');

  targets.length &&
    targets.forEach(target => {
      target.classList.add('is-animated');
      const observer = new IntersectionObserver(callback, options);
      observer.observe(target);
    });
});
